module.exports = __webpack_public_path__ + "media/images/emblems/Schlierbach_LU-829305250de10c5b04b1cf5ae76faf7b.png";